import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { apiCall } from "../../data/useFetcher";
import useErrorStore from "../../data/stores/errorStore";
import StepForm from "./StepForm";

// Types
interface FormData {
  toolName: string;
  description: string;
  contactEmailAddress: string;
  website: string;
  webinar: string;
  logo: string;
  additionalInformation: string;
  toolCreatedBy: string;
  toolOwnerAddress: string;
  organizationName: string;
}

interface ToolSelection {
  [key: string]: string | string[];
}

// Add Tools Component
const AddTools: React.FC = () => {
  const navigate = useNavigate();
  const [newD, setNewD] = useState<any>(null);
  const [getSearch] = useSearchParams();
  const [preloading, setPreLoading] = useState(true);
  const { returnErrors } = useErrorStore();

  const searchChecker =
    getSearch?.get("contactEmailAddress") && getSearch?.get("requestId");

  useEffect(() => {
    if (searchChecker) {
      const onValidateSubmit = async () => {
        const { response, errArr, errMsg } = await apiCall({
          type: "get",
          url: `/api/v1/tools/new-request/manage-new-request?contactEmailAddress=${getSearch?.get(
            "contactEmailAddress"
          )}&requestId=${getSearch?.get("requestId")}`,
          noToast: true,
        });

        if (errArr) {
          setPreLoading(false);
          returnErrors(errArr);
          navigate("/");
          return;
        }
        if (errMsg) {
          setPreLoading(false);
          toast.error(errMsg);
          navigate("/");
          return;
        }

        setPreLoading(false);
        if (response) {
          const newD = response?.data || response;
          const updReset: any = {};
          const newSelect: any = {};

          if (newD?.contactEmailAddress)
            updReset.contactEmailAddress = newD?.contactEmailAddress;
          if (newD?.toolName) updReset.toolName = newD?.toolName;
          if (newD?.website) updReset.website = newD?.website;
          if (newD?.description) updReset.description = newD?.description;

          if (Object.keys(updReset)?.length > 0) {
            setNewD((prev: any) => ({ ...prev, basic: updReset }));
          }

          if (newD?.region) newSelect.REGION = [newD?.region];
          if (newD?.country) newSelect.COUNTRY = [newD?.country];
          if (newD?.toolCategory)
            newSelect["APPLICATION LEVEL"] = newD?.toolCategory;

          if (Object.keys(newSelect)?.length > 0) {
            setNewD((prev: any) => ({ ...prev, select: newSelect }));
          }
        }
      };
      onValidateSubmit();
    } else {
      setPreLoading(false);
    }
  }, [getSearch, navigate, returnErrors]);

  if (preloading) return <>Loading...</>;

  return (
    <StepForm newD={newD?.basic} newSelect={newD?.select} others={undefined} />
  );
};

export default AddTools;
export { StepForm as MainToolComponent };
